import React from 'react';
import { withStyles } from 'tss-react/mui';

import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';

import ApiService from '../../../common/services/ApiService';
import ReportConfig from '../../../common/config/Reports';
import ProfilingFilters from './ProfilingFilters';
import ReportTable from '../../../common/components/table/ReportTable';

const styles = theme => ({
  exportHeader: {
    padding: `${theme.typography.pxToRem(22)} ${theme.typography.pxToRem(25)} ${theme.typography.pxToRem(25)} ${theme.typography.pxToRem(25)}`,
  },
});

class Profiling extends React.Component {

  constructor(props) {
    super(props);
    this.api = new ApiService();
    this.state = {
      filters: null,
      loading: true,
      reportData: [],
    };
  }

  componentDidMount = () => {
    this.getAllData();
  };

  componentDidUpdate(prevProps, prevState) {
    if (prevState.filters !== this.state.filters) {
      this.getAllData();
    }
  }

  getAllData = () => {
    var filters = {};
    var pagination = null;

    if (this.state.filters != null) {
      filters = this.state.filters;
    }

    var options = {
      filters,
      pagination,
      sorting: {
        'direction': 'asc',
        'field': '',
      },
    };

    this.api.search('', options, 'reports/profile').then((data) => {
      this.setState({
        loading: false,
        reportData: data.data,
      });
    }).catch((ex) => {
      console.error(ex);
      this.setState({ loading: false });
    });
  };

  handleApplyFilters = (filters) => {
    this.setState({ loading: true, filters: filters });
  };

  handleExport = () => {
    var sortingParams = { direction: 'asc', field: '' };

    return this.api.fullUrl(
      '/api/v1/reports/profile.csv',
      this.state.filters,
      null,
      null,
      sortingParams,
      null
    );
  };

  render() {
    const { classes, passportPeriod } = this.props;
    const { loading, reportData } = this.state;

    return (
      <Grid container className={classes.profilingReport} spacing={2}>
        <Grid size={12}>
          <Paper>
            <ProfilingFilters
              handleApplyFilters={this.handleApplyFilters}
              passportPeriod={passportPeriod}
            />
          </Paper>
        </Grid>
        <Grid size={12}>
          <Paper>
            <Grid
              container
              className={classes.exportHeader}
              justifyContent="space-between"
            >
              <Typography variant="h6">Profiling</Typography>
              <a href={`${this.handleExport()}`} target="_blank">
                <Button color="secondary" size="small" variant="contained">
                  <Typography variant="button">Export</Typography>
                </Button>
              </a>
            </Grid>
            {loading ? (
              <span>Loading...</span>
            ) : (
              <ReportTable
                reportData={reportData}
                tableConfig={ReportConfig.profiling}
              />
            )}
          </Paper>
        </Grid>
      </Grid>
    );
  }

}

export default withStyles(Profiling, styles, { withTheme: true });
